
(function($){

     $('.main-slider').slick({
        infinite: true,
        speed: 1000,
        fade: true,
        cssEase: 'linear',
        arrows: true,
        autoplay: true,
        autoplaySpeed: 8000,
    });
    $('.article-slider').slick({
        dots: false,
        fade: true,
        arrows: true,
        speed: 500
    });

})(jQuery);
